import { observer } from 'mobx-react-lite'
import { TurnInto } from 'almanac-ui/icons/28'
import { useModals } from 'almanac-ui/Modal'
import { useRootStore } from 'stores/RootStore'
import { useAlmanacEditorState } from 'stores/EditorState'
import { ArticleFlat } from 'types'
import { BaseNextStep } from './BaseNextStep'
import { TurnIntoWizard } from 'components/Wizards/TurnInto/TurnIntoWizard'
import { SourceType } from 'components/Wizards/TurnInto/Source/Types'
import { markdownSerializer } from 'common/Prose/components/TextInlineFormatBar/components/FormatBars/markdownSerializer'
import { BlazeIcon } from 'components/BlazeIcon/BlazeIcon'

interface Props {
  article: ArticleFlat
  layerId: string
}

export const OutlineNextStep = observer(function OutlineNextStep({ article, layerId }: Props) {
  const { openModal } = useModals()
  const { docStore } = useRootStore()
  const editorState = useAlmanacEditorState()
  const doc = editorState?.view.state.doc

  const documentAsMarkdown = doc ? markdownSerializer.serialize(doc) : undefined

  const handleTurnInto = () => {
    if (editorState == null) {
      return
    }

    docStore?.rightRailStore.setActiveTab(undefined)
    openModal(TurnIntoWizard, {
      sourceType: SourceType.File,
      fromDocProps: {
        documentAsMarkdown,
        selection: editorState.selection,
      },
    })
  }

  return (
    <BaseNextStep
      actionText="Turn your outline into a full piece of content"
      icon={<BlazeIcon icon={<TurnInto />} color="var(--blaze-light-purple)" />}
      onPress={handleTurnInto}
    />
  )
})
